import type { ReactNode } from "react";

export interface WizardStep {
  id: string;
  label: string;
}

export interface WizardStepperProps {
  steps: WizardStep[];
  /** Indeks bieżącego kroku (0-based). */
  current: number;
  /** Najdalszy odblokowany krok — dalsze są niedostępne. */
  maxReached: number;
  onGoTo: (index: number) => void;
  children: ReactNode;
  footer?: ReactNode;
}

export function WizardStepper({ steps, current, maxReached, onGoTo, children, footer }: WizardStepperProps) {
  return (
    <div className="ui-wizard">
      {/* `role="list"`: Safari gubi semantykę listy przy `list-style: none`. */}
      <ol className="ui-wizard__steps" role="list">
        {steps.map((s, i) => {
          const state = i === current ? "current" : i < current || i <= maxReached ? "done" : "todo";
          return (
            <li key={s.id}>
              <button
                type="button"
                className="ui-wizard__step"
                data-state={state}
                disabled={i > maxReached}
                aria-current={i === current ? "step" : undefined}
                onClick={() => onGoTo(i)}
              >
                <span className="ui-wizard__num">{i + 1}</span>
                <span>{s.label}</span>
              </button>
            </li>
          );
        })}
      </ol>
      <div className="ui-wizard__body">{children}</div>
      {footer ? <div className="ui-wizard__foot">{footer}</div> : null}
    </div>
  );
}
